// extracted by mini-css-extract-plugin
export default {"root":"SpecDescription_root__A58iH","darkText":"SpecDescription_darkText__YE9eG","outline":"SpecDescription_outline__bJXp+","centered":"SpecDescription_centered__7QEKw"};